/* eslint-disable import/first */
import React from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { Button } from '@material-ui/core';
const { selectCountryValidations } = Slices.configSlice;
const { selectCurrentCountry } = Slices.profileSlice;
import css from './index.module.scss';

const CustomError = ({ Badge, errorType, futureError, locale, performAction, errorResponse }) => {
  const country = useSelector(selectCurrentCountry);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  console.log('errorType and errorResponse =====>', { errorResponse, errorType });
  return (
    <>
      {/* <div className={css.futureDateBadge}>{Badge}</div> */}
      <div className={css.errorDrawer}>
        <div className={css.heading}>{errorType && errorType.data.heading[locale]}</div>
        <div className={css.error}>{errorResponse ? errorResponse : null}</div>
        <div className={css.errorNote}>{(errorType && errorType.data.note[locale]) || ''}</div>
        <div className={css.buttons}>
          {errorType &&
            errorType.data.attributes.map((button) => {
              if (button.action === 'advance-slot' && futureError && futureError !== '') {
                return '';
              }
              let href = '';
              if (button.action === 'DIALER') {
                href = 'tel:' + countryValidations.customerCare;
              }
              return (
                <Button
                  href={href}
                  onClick={(event) => performAction(event, button)}
                  variant={button.default ? 'contained' : 'outlined'}
                  color="primary"
                >
                  {button[locale]}
                </Button>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default CustomError;
